export default function SectionHeader({ eyebrow, title, children, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div className="mb-2 text-xs font-bold uppercase tracking-wide text-civic-blue">{eyebrow}</div>
      )}
      <h2 className="text-2xl font-bold text-civic-navy sm:text-3xl">{title}</h2>
      {children && <p className="mt-3 text-base leading-7 text-slate-600">{children}</p>}
    </div>
  );
}
